<template>
  <div class="kds-subbar">
    <button
      v-for="filter in filters"
      :key="filter.value"
      class="kds-filter-chip"
      :class="{ active: activeFilter === filter.value }"
      @click="$emit('update-active-filter', filter.value)"
    >
      <v-icon small class="mr-1">{{ filter.icon }}</v-icon>
      <span class="kds-filter-label">{{ filter.label }}</span>
      <span class="kds-filter-count">{{ filter.count }}</span>
    </button>
  </div>
</template>

<script>
export default {
  name: "KdsTypeFilterBar",
  props: {
    filters: { type: Array, default: () => [] },
    activeFilter: { type: [String, Number], default: "all" },
  },
};
</script>

<style scoped>
.kds-subbar {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
  padding: 8px 18px;
  background: #181c2a;
  border-bottom: 1px solid #2a2f42;
}

.kds-filter-chip {
  display: flex;
  align-items: center;
  gap: 6px;
  border: 1px solid #333952;
  background: #232842;
  color: #cfd3e6;
  border-radius: 20px;
  padding: 6px 14px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.15s, color 0.15s;
}

.kds-filter-chip.active {
  background: #3b5bfd;
  border-color: #3b5bfd;
  color: #fff;
}

.kds-filter-count {
  background: rgba(255, 255, 255, 0.15);
  border-radius: 10px;
  padding: 0 7px;
  font-size: 12px;
}
</style>
